/* eslint-disable react-hooks/exhaustive-deps */
import styles from "./index.module.scss";

export function MetricV2({
  count,
  label,
  ...props
}) {

  return (
    <div
      className={styles.metric}
      style={{ width: `${props.fullWidth ? "33%" : "auto"}` }}
    >
      <span
        className={styles.count}
        style={{
          color: `${props.color && props.color}`,
          fontSize: `${props.fontSize && props.fontSize}`,
        }}
      >
        {count ? count : 0}{" "}
      </span>
      <span className={styles.label}>{label}</span>
    </div>
  );
}